__turbopack_context__.v({
  "buttons": "index-module__l-Uvxq__buttons",
  "onlyOneButton": "index-module__l-Uvxq__onlyOneButton",
});
